import { FileType } from '../features/data-set/data-set';

export type HospitalsOverviewResponse = {
  hospitals: {
    hospitalId: number;
    hospitalName: string;
    dataSets: { dataSetId: number; dataSetName: string }[];
  }[];
};

export type HospitalsListResponse = {
  hospitals: { id: number; country: string; useCases: number[] }[];
};

export type HospitalInfoResponse = {
  id: number;
  name: string;
  address: string;
  latitude: number;
  longitude: number;
};

export type HospitalDataSetsResponse = {
  hospitalId: number;
  useCases: {
    useCase: number;
    lastSync: string;
    dataSets: {
      dataSetId: number;
      dataSetName: string;
      fileName: string;
      fileType: FileType;
    }[];
  }[];
};

export type DataSetData = {
  table: DataSetTableResponse;
};

export type DataSetTableResponse = {
  id: number;
  snapshotId: number;
  tableData: TableDataResponse;
};

type TableDataResponse = {
  features: TableFeatureResponse[];
  lastSync: string;
  useCase: number;
};

export enum DataType {
  Int = 'Int',
  Float = 'Float',
  Bool = 'Bool',
  String = 'String',
  Date = 'Date',
  TimeStamp = 'TimeStamp',
  Category = 'Category',
}

export type TableFeatureResponse = {
  id: number;
  featureId?: number;
  name?: string;
  description?: string;
  ontology?: string;
  dataType?: DataType;
  entityType?: string;
  visibility?: string;
  acceptedValues?: string[];
  minDate?: string;
  maxDate?: string;
  minValue?: number;
  maxValue?: number;
  profile: FeatureProfileResponse;
};

type FeatureProfileResponse = {
  entropy?: number;
  density?: number;
  missingPercentage?: number;
  dataTypeValidity?: number;
  uniqueness?: number;
  accuracyScore?: number;
  minValue?: number;
  maxValue?: number;
  mean?: number;
  median?: number;
  standardDeviation?: number;
  skewness?: number;
  kurtosis?: number;
  medianAbsoluteDeviation?: number;
  interQuartileRange?: any;
  minDate?: string;
  maxDate?: string;
  medianDate?: string;
  interQuartileRangeDate?: any;
  imbalance?: number;
  constancy?: number;
  mode?: any;
  valueCounts?: string;
  correlationMatrix?: { [value: string]: number };
};

export type AdminTableResponse = {
  items: AdminTableItemResponse[];
};

export type AdminTableItemResponse = {
  attemptId: number;
  hospitalName: string;
  date: string;
  isSuccess: boolean;
};
